import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { revalidate } from '@/services/revalidate/revalidate';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const useAddMainPageHost = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation('addMainPageHost', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: ['main-page-stores'] });
      toast.success(res.message);
      await revalidate(['all']);
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });

  return { mutateAsync, isPending };
};

export default useAddMainPageHost;
